import * as React from "react";
const SvgFiRrCurling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-curling_svg__a)">
      <path
        fill="#062147"
        d="m19.854 10.293-.316-1.263A3.994 3.994 0 0 0 15.657 6H7.136l.144-.65A2.98 2.98 0 0 1 10.209 3H17a1 1 0 1 0 0-2h-6.791a4.97 4.97 0 0 0-4.882 3.916L4.131 10.3A6.01 6.01 0 0 0 0 16v2a6.006 6.006 0 0 0 6 6h12a6.006 6.006 0 0 0 6-6v-2a6.01 6.01 0 0 0-4.146-5.707M15.657 8A2 2 0 0 1 17.6 9.515l.12.485H6.247l.444-2zM6 12h12a4 4 0 0 1 4 4H2a4 4 0 0 1 4-4m12 10H6a4 4 0 0 1-4-4h20a4 4 0 0 1-4 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-curling_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCurling;
